import React from 'react';
import { IValueContactListRow } from './interface';
import { ValueRow } from '../ValueRow';
import { ChipList } from '../../ChipList';
import { Chip } from '../../ChipList/interfaces';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../routes/Routes';

export const ValueContactListRow: React.FC<IValueContactListRow> = ({
  label,
  contacts,
  width,
}): JSX.Element => {
  const navigate = useNavigate();

  const chips = contacts?.map((contact): Chip => {
    return {
      label: `${contact.firstName} ${contact.lastName}`,
      onClick: () => {
        navigate(ROUTES.contacts.details(contact.id));
      },
    };
  });

  return (
    <ValueRow label={label} width={width} verticalAlign="top">
      {chips?.length ? <ChipList chips={chips} /> : '-'}
    </ValueRow>
  );
};
